/**
 * Mappers for assigned employees list operations
 */

import type {
  LC_AssignedEmployee,
  LC_AssignedEmployeesListOut,
  AssignedEmployee,
  AssignedEmployeesListResult,
} from '../types';


export function mapAssignedEmployeeToModel(
  transport: LC_AssignedEmployee,
): AssignedEmployee {
  return {
    rut: transport.employeeTaxIdentificationNumber,
    name: transport.employeeName.trim(),
    status: transport.status,
    adminGroupsCount: transport.adminGroupsCount,
    memberGroupsCount: transport.memberGroupsCount,
    adminGroupNames: transport.adminGroupNames,
    memberGroupNames: transport.memberGroupNames,
  };
}

export function mapAssignedEmployeesListResultToModel(
  transport: LC_AssignedEmployeesListOut,
): AssignedEmployeesListResult {
  return {
    items: transport.data ? transport.data.map(mapAssignedEmployeeToModel) : [],
    totalRecords: transport.pagination.totalRecords,
  };
}
